// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1NJ5z","title":"AfterFrontImage_title__2cT6a"};